module.exports = __webpack_public_path__ + "img/graduationcap_fill.b111f514.svg";